// recursively walks document data and replaces mention nodes with their resolved values from the variable map
// parses <span data-type="mention" data-id="variableName">...</span> and replaces with the resolved value
export function interpolateVariables(
    data: Record<string, any>,
    variableMap: Record<string, string>
): Record<string, any> {
    const mentionRegex = /<span[^>]*data-type="mention"[^>]*data-id="([^"]+)"[^>]*>[^<]*<\/span>/g;

    function interpolateString(str: string): string {
        return str.replace(mentionRegex, (match, id) => {
            const trimmed = id.trim();
            return Object.hasOwn(variableMap, trimmed) ? variableMap[trimmed] : match;
        });
    }

    function walk(value: unknown): unknown {
        if (typeof value === 'string') {
            return interpolateString(value);
        }
        if (Array.isArray(value)) {
            return value.map(walk);
        }
        if (value && typeof value === 'object') {
            const result: Record<string, any> = {};
            for (const [k, v] of Object.entries(value)) {
                result[k] = walk(v);
            }
            return result;
        }
        return value;
    }

    return walk(data) as Record<string, any>;
}
